const _ = require('lodash');

const emptyParams = {
    productId: undefined,
    recipeId: undefined,
    cardId: undefined,
    name: undefined,
    pageNumber: undefined
};

module.exports = function ($state, searchService, $stateParams, breakpointsService, shopPageStateService, moveFocus, searchPhraseActionService) {
    return {
        restrict: 'EA',
        link(scope, element) {
            scope.searchTerm = $stateParams.searchTerm || '';
            scope.autocompleteResults = [];
            scope.searchService = searchService;
            scope.lfSearchActive = false;

            scope.breakpointsService = breakpointsService;

            const goToState = function (state, params) {
                $state.go(state, _.assign(emptyParams, params));
            };

            const continueSearch = function () {
                searchService.getSearchCounts(scope.searchTerm, false).then(function () {
                    const nextState = searchService.determineStateToShow(scope.searchTerm);
                    goToState(nextState.name, nextState.params);
                });
            };

            scope.search = function () {
                if (breakpointsService.isSmallFormat()) {
                    shopPageStateService.triggerPanel('left', true);
                }

                if (scope.searchTerm.length < 1) {
                    return;
                }

                searchPhraseActionService.getSearchPhraseAction(scope.searchTerm).then(function (searchActionResult) {
                    if (searchActionResult && searchActionResult.Action) {
                        searchPhraseActionService.performSearchPhraseAction(searchActionResult, false).then(continueSearch);
                    } else {
                        continueSearch();
                    }
                    moveFocus('#center-panel');
                });
            };

            scope.populateAutocompleteList = _.throttle(function () {
                searchService.getSearchSuggestion(scope.searchTerm).then(function (response) {
                    scope.autocompleteResults = document.activeElement === element.find('.globalHeader-searchInput')[0] || document.activeElement === element.find('.globalHeader-searchBarInput')[0]
                        ? response.SearchSuggestion
                        : [];
                });
            }, 500);

            scope.onFocus = function () {
                if (breakpointsService.isInLargeFormat) {
                    scope.lfSearchActive = true;
                }
            };

            scope.onFocusLost = function () {
                if (breakpointsService.isInLargeFormat && document.activeElement.parentElement.id !== 'multisearchLinkContainer') {
                    scope.lfSearchActive = false;
                } else if (breakpointsService.isInMediumFormatGlobalHeader || breakpointsService.isInMediumFormat) {
                    scope.lfSearchActive = false;
                }
            };
        }
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/search/search-directive.js
 **/